import { Link } from "react-router-dom";
import { useLang, pickTitle } from "../lib/i18n";

export default function Ticker({ items }) {
  const { t, lang } = useLang();
  if (!items?.length) return null;
  const doubled = [...items, ...items];
  return (
    <div
      data-testid="breaking-ticker"
      className="bg-deepgreen text-paper border-y-2 border-gold flex items-stretch overflow-hidden"
    >
      <div className="shrink-0 bg-brk px-4 py-2 flex items-center gap-2 font-mono text-xs font-bold tracking-[0.2em] z-10">
        <span className="w-2 h-2 rounded-full bg-paper animate-pulse" />
        {t.breaking}
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track items-center gap-10 whitespace-nowrap py-2 px-6">
          {doubled.map((a, i) => (
            <Link
              key={`${a.id}-${i}`}
              to={`/article/${a.id}`}
              data-testid={`ticker-item-${i}`}
              className="text-sm text-gold-light hover:text-gold transition-colors"
            >
              <span className="text-gold mr-2">◆</span>
              {pickTitle(a, lang)}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
